(function() {

  angular
  .module('meanApp')
  .factory('Allergen', Allergen);

  Allergen.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Allergen ($http, httpAuth, $rootScope, Model) {
    var Allergen = function (userData) {
        Model.apply(this, arguments);
    };

    Allergen.APIPath = 'allergens';
    Allergen.prototype = {
        getAPIPath: function() {
            return Allergen.APIPath;
        },
        getRisk: function() {
            var risk = 'LOW';
            if (this.risk > 50) {
                risk = 'MEDIUM';
            }
            else if(risk === 100) {
                risk = 'HIGH';
            }
            return risk;
        }
    };
    
    angular.extend(Allergen.prototype, Model.prototype);

    return Allergen;
  };

})();